const dumpMatrix = function (matrix) {
    let output = "[";
    for (let row = 0; row < matrix.length; row++) {
        output += "\n  [";
        for (let col = 0; col < matrix[row].length; col++) {
            output += matrix[row][col] + (col < matrix[row].length - 1 ? ", " : "");
        }
        output += "]";
    }
    output += "]";
    return output;
}

const emptyMatrix = function (rows, columns, defaultValue = false) {
    let matrix = [];
    for (var i = 0; i < rows; i++) {
        matrix[i] = [];
        for (var j = 0; j < columns; j++) {
            matrix[i][j] = defaultValue;
        }
    }
    return matrix;
}

export { dumpMatrix, emptyMatrix };